import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'

import { prepareData } from 'helpers/prepare-req-data'
import { prepParams } from 'helpers/prep-req-url'
import { getRespData  } from 'helpers/get-resp-data'
import client from 'api'
import _ from 'lodash'

import { v4 as uuid4 } from 'uuid'


const initialState = {
    startProcess304012Status: 'idle',
    startProcess304012Error: undefined as any,
    loadUserParamsProcess304012Status: 'idle',
    loadUserParamsProcess304012Error: undefined as any,

    process304012List: [] as any[],
    defaultValues: undefined as any,
    job: undefined as any,
    filterValues: {} as any,
    filterLookupValues: {} as any,

    directLoad: false,
    load: false,
    activeDivRef: null as any,

    filterValuesId: null,
    valuesFromDB: false,
    filterVisibleId: null,
    filterVisible: true,
}


export const startProcess304012 = createAsyncThunk('process304012Slice/startProcess304012', async ({ process304012 }: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.post(
        `/api/ixweb/StartProcess304012/`,
        prepareData(process304012),
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: value1.map((x: any) => ({
            ...x,
        })),
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { startProcess304012Status } = getState().process304012Slice
        return startProcess304012Status !== 'pending'
    }
})

export const loadUserParamsProcess304012 = createAsyncThunk('process304012Slice/loadUserParamsProcess304012', async (_: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.get(
        `/api/ixweb/LoadUserParamsProcess304012/`,
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: value1.map((x: any) => ({
            ...x,
        })),
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { loadUserParamsProcess304012Status } = getState().process304012Slice
        return loadUserParamsProcess304012Status !== 'pending'
    }
})

const Process304012Slice = createSlice({
    name: 'process304012Slice',
    initialState,
    reducers: {
        resetstartProcess304012: (state) => {
            state.job = undefined
            state.startProcess304012Error = undefined
        },
        resetstartProcess304012Error: (state) => {
            state.startProcess304012Error = undefined
        },
        resetloadUserParamsProcess304012: (state) => {
            state.defaultValues = undefined
            state.loadUserParamsProcess304012Error = undefined
        },
        resetloadUserParamsProcess304012Error: (state) => {
            state.loadUserParamsProcess304012Error = undefined
        },
        removeFromProcess304012ListById: (state, action) => {
            state.process304012List = state.process304012List.filter((x: any) => x.HDR_ID !== action.payload)
        },
        removeFromProcess304012ListByIds: (state, action) => {
            state.process304012List = state.process304012List.filter((x: any) => action.payload.indexOf(x.HDR_ID) === -1)
        },
        setFilterValues: (state, action) => {
            if (action.payload === undefined || action.payload === null) {
                state.filterValues = {}
            } else {
                state.filterValues = { ...state.filterValues, ...action.payload }
            }
        },
        setFilterLookupValue: (state, action) => {
            const { name, value, formValue } = action.payload
            if (name) {
                state.filterLookupValues[name] = value
                state.filterValues[name] = formValue
            }
        },
        setDirectLoad: (state, action) => { state.directLoad = action.payload },
        setLoad: (state, action) => { state.load = action.payload },
        setActiveDivRef: (state, action) => { state.activeDivRef = action.payload},
        setFilterValuesId: (state, action) => {
            state.filterValuesId = action.payload
        },
        setValuesFromDB: (state, action) => {
            state.valuesFromDB = action.payload
        },
        setFilterVisibleId: (state, action) => {
            state.filterVisibleId = action.payload
        },
        setFilterVisible: (state, action) => {
            state.filterVisible = action.payload
        },
        preloadData: (state, action) => {
            state.process304012List = action.payload.map((x: any) => ({ ...x, HDR_ID: uuid4()}))
            state.startProcess304012Status = 'preloaded'
        },
        clearPreloadedData: (state) => {
            state.process304012List = []
            state.startProcess304012Status = 'idle'
        },
    },
    extraReducers: builder => {
        builder.addCase(startProcess304012.pending, (state) => {
            state.startProcess304012Status = 'pending'
            state.startProcess304012Error = undefined
        })
        builder.addCase(startProcess304012.fulfilled, (state, action) => {
            state.startProcess304012Status = 'idle'

            {
                state.job = action.payload

            }
        })
        builder.addCase(startProcess304012.rejected, (state, action) => {
            state.startProcess304012Status = 'error'
            if (action.error.message !== 'Rejected') {
                state.startProcess304012Error = action.error.message
            } else {
                state.startProcess304012Error = action.payload
            }
        })

        builder.addCase(loadUserParamsProcess304012.pending, (state) => {
            state.loadUserParamsProcess304012Status = 'pending'
            state.loadUserParamsProcess304012Error = undefined
        })
        builder.addCase(loadUserParamsProcess304012.fulfilled, (state, action) => {
            state.loadUserParamsProcess304012Status = 'idle'

            {
                state.defaultValues = action.payload

            }
        })
        builder.addCase(loadUserParamsProcess304012.rejected, (state, action) => {
            state.loadUserParamsProcess304012Status = 'error'
            if (action.error.message !== 'Rejected') {
                state.loadUserParamsProcess304012Error = action.error.message
            } else {
                state.loadUserParamsProcess304012Error = action.payload
            }
        })

    }
})

export const {
    resetstartProcess304012,
    resetstartProcess304012Error,
    resetloadUserParamsProcess304012,
    resetloadUserParamsProcess304012Error,
    removeFromProcess304012ListById,
    removeFromProcess304012ListByIds,
    setFilterValues,
    setFilterLookupValue,
    setDirectLoad,
    setLoad,
    setActiveDivRef,
    setFilterValuesId,
    setValuesFromDB,
    setFilterVisible,
    setFilterVisibleId,
    preloadData,
    clearPreloadedData,
} = Process304012Slice.actions
export default Process304012Slice.reducer
